import React, { useCallback, useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { ApiClient } from "../../ApiClient"
import { useAuth0 } from "@auth0/auth0-react"
import { MessageType, useMessageReport } from "../../components/MessageReporter"

export const TranslationAdd = () => {
    const { addMessage } = useMessageReport()
    const navigate = useNavigate()
    const { user, getAccessTokenSilently } = useAuth0()

    const [translation, setTranslation] = useState({
        key: "",
        app: "USER",
    })

    const [languages, setLanguages] = useState({
        EN: { display: "English", language: "EN", translation: "" },
        NL: { display: "Dutch", language: "NL", translation: "" },
        SE: { display: "Swedish", language: "SE", translation: "" },
        DE: { display: "German", language: "DE", translation: "" },
        ES: { display: "Spanish", language: "ES", translation: "" },
    })

    const updateTranslation = useCallback(() => {
        if (translation.key === "" || Object.values(languages).some((l) => l.translation === "")) {
            addMessage(
                "Translation incomplete",
                "One of the translations is missing",
                MessageType.error
            )
            return
        }
        getAccessTokenSilently()
            .then((token) =>
                Promise.all(
                    Object.entries(languages).map(([k, v]) =>
                        ApiClient.post(
                            `/v2/management/translations`,
                            {
                                app: translation.app,
                                key: translation.key,
                                language: k,
                                translation: v.translation,
                                changedby: user.email,
                            },
                            {
                                Authorization: `Bearer ${token}`,
                            }
                        )
                    )
                )
            )
            .then(() => {
                navigate(`/translations`)
            })
            .catch((err) => {
                addMessage(
                    "Failed to update translation",
                    "Something went wrong while updating the translation, " +
                        "see the console for more details.",
                    MessageType.error,
                    err
                )
            })
    }, [translation, languages, user, getAccessTokenSilently, navigate, addMessage])

    return (
        <Row className="content-section">
            <Col>
                <h2>Add translation</h2>
                <Form.Group className="mb-3">
                    <Form.Label>Key</Form.Label>
                    <Form.Control
                        type="text"
                        value={translation?.key}
                        onChange={(e) =>
                            setTranslation((curr) => ({ ...curr, key: e.target.value }))
                        }
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    {Object.entries(languages).map(([k, v]) => (
                        <>
                            <Form.Label>{v.display}</Form.Label>
                            <Form.Control
                                type="text"
                                value={v?.translation}
                                onChange={(e) =>
                                    setLanguages((curr) => ({
                                        ...curr,
                                        [k]: { ...v, translation: e.target.value },
                                    }))
                                }
                            />
                        </>
                    ))}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>App</Form.Label>
                    <Form.Select
                        onChange={(e) =>
                            setTranslation((curr) => ({ ...curr, app: e.target.value }))
                        }
                        value={translation?.app}
                    >
                        <option value="USER">USER</option>
                        <option value="INSTALLER">INSTALLER</option>
                    </Form.Select>
                </Form.Group>
                <button onClick={updateTranslation} className="btn btn-primary">
                    Save
                </button>
            </Col>
        </Row>
    )
}
